// v2.221.00: núcleo operacional provisório/ACK para registros offline-first.
// O servidor continua sendo a fonte de verdade: local cria/edita como pendente,
// servidor confirma, carimba revisão e remove o marcador -PRV.

export function isProvisionalCode(value) {
  return String(value || "").trim().toUpperCase().endsWith("-PRV");
}

export function stripProvisionalSuffix(value) {
  return String(value || "").trim().replace(/-PRV$/i, "");
}

// v2.221.11: UDT é apenas marcador visual de atualização pendente.
// Não deve ser gravado no recordNumber real/persistido.
export function stripUpdatePendingSuffix(value) {
  return String(value || "").trim().replace(/-UDT$/i, "");
}

export function stripOperationalSuffixes(value) {
  let clean = String(value || "").trim();
  for (let i = 0; i < 3; i += 1) {
    const next = clean.replace(/-(PRV|UDT)$/i, "").trim();
    if (next === clean) break;
    clean = next;
  }
  return clean;
}

export function isUpdatePendingCode(value) {
  return String(value || "").trim().toUpperCase().endsWith("-UDT");
}

export function appendUpdatePendingDisplaySuffix(value) {
  const clean = stripOperationalSuffixes(value);
  return clean ? `${clean}-UDT` : "UDT";
}

// v3.2.12: DEL — exclusão pendente aguardando confirmação do servidor.
// Simétrico a PRV (criação pendente) e UDT (atualização pendente).
export function isDeletePendingCode(value) {
  return String(value || "").trim().toUpperCase().endsWith("-DEL");
}

export function stripDeletePendingSuffix(value) {
  return String(value || "").trim().replace(/-DEL$/i, "");
}

export function appendDeletePendingDisplaySuffix(value) {
  const clean = stripDeletePendingSuffix(
    String(value || "").trim().replace(/-UDT$/i, "").replace(/-PRV$/i, "")
  );
  return clean ? `${clean}-DEL` : "DEL";
}

export function appendProvisionalSuffix(value) {
  const clean = stripProvisionalSuffix(value);
  return clean ? `${clean}-PRV` : "PRV";
}

export function createOperationalOperationId(prefix = "op") {
  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${Date.now()}_${rand}`;
}

function basePendingMeta({ userName = "", operationType = "update", at = null, operationMeta = null } = {}) {
  const ts = at || new Date().toISOString();
  const opId = createOperationalOperationId(operationType === "create" ? "create" : "update");
  const meta = operationMeta && typeof operationMeta === "object" ? operationMeta : {};
  return {
    localOperationId: opId,
    lastLocalOperationId: opId,
    lastLocalOperationType: operationType,
    pendingOperationId: opId,
    pendingOperationType: operationType,
    pendingLocalChange: true,
    localUpdatedAt: ts,
    syncStatus: "pending",
    serverConfirmed: false,
    serverAckAt: null,
    baseServerRevision: null,
    updatedAt: ts,
    updatedBy: userName || "",
    ...meta,
  };
}

export function markOperationalCreatePending(record = {}, { userName = "", at = null, operationMeta = null } = {}) {
  const ts = at || new Date().toISOString();
  return {
    ...record,
    ...basePendingMeta({ userName, operationType: "create", at: ts, operationMeta }),
    provisional: true,
    pendingLocalCreate: true,
    pendingLocalUpdate: false,
    provisionalCreatedAt: record?.provisionalCreatedAt || ts,
    recordNumberStatus: record?.recordNumberStatus || "provisional",
  };
}

export function markOperationalUpdatePending(record = {}, { userName = "", at = null, operationType = "update", operationMeta = null } = {}) {
  const ts = at || new Date().toISOString();
  return {
    ...record,
    ...basePendingMeta({ userName, operationType, at: ts, operationMeta }),
    pendingLocalCreate: Boolean(record?.pendingLocalCreate),
    pendingLocalUpdate: true,
  };
}
